// import apiWrapper from 'Helpers/apiWrapper'
// import extractApiData from 'Helpers/extractApiData'
import axios from 'axios'
import { logApiTiming, logApiError } from 'Helpers/logger'

const endpoints = (baseURL => {
  return {
    getShortUrlApi: () => `${baseURL}/api/v1.0/urls`
  }
})(process.env.URLSHORTNER_URL)

const makeApiWrapper = () => {
  const _axios = axios.create()

  _axios.interceptors.request.use(config => {
    return {
      ...config,
      _start: Date.now()
    }
  })

  _axios.interceptors.response.use(
    response => {
      if (response && response.config && response.config._start) {
        const { hostname: apiHostname, pathname: apiPathname } = new URL(
          response.config.url
        )

        logApiTiming({
          apiTime: Date.now() - response.config._start,
          apiUrl: response.config.url,
          apiMethod: response.config.method,
          apiHostname,
          apiPathname
        })
      }
      return response
    },
    error => {
      if (!error || !error.response || !error.response.config) return error
      //
      const { hostname: apiHostname, pathname: apiPathname } = new URL(
        error.response.config.url
      )

      logApiError({
        apiTime: Date.now() - error.response.config._start,
        apiUrl: error.response.config.url,
        apiMethod: error.response.config.method,
        apiHostname,
        apiPathname,
        apiError: JSON.stringify(error.response.data)
      })
      //
      return Promise.reject(error.response)
    }
  )

  return _axios
}

const apiWrapper = makeApiWrapper()

export const getShortUrlApi = (urlLP, trackOptin, idConsole, token) => {
  const url = endpoints.getShortUrlApi()

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify({
      LongUrl: urlLP,
      TrackOptinEnabled: !!trackOptin,
      CampaignCode: `idConsole:${idConsole}`
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }).then(res => res.data)
}
